import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-screen h-screen flex flex-row flex-nowrap items-center justify-center" }
const _hoisted_2 = {
  key: 0,
  class: "h-screen w-screen flex flex-col gap-12 items-center justify-center"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "logging in", -1)
const _hoisted_4 = {
  key: 1,
  class: "flex flex-col flex-nowrap gap-20 items-center pb-82 rise-animation"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "velocity", -1)
const _hoisted_6 = { class: "flex gap-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx._loggingIn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Icon, {
            icon: ['fal', 'spinner-third'],
            spin: "",
            style: { width: '120px', height: '120px' }
          }),
          _hoisted_3
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args))),
              class: "btn-primary-outline text-center self-center p-cell rounded-mention"
            }, " login "),
            (_ctx._signedIn)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args))),
                  class: "btn-primary text-center self-center p-cell rounded-mention"
                }, " go to my workspace "))
              : _createCommentVNode("", true)
          ])
        ]))
  ]))
}